import { MonitorPaygPrice } from "Hooks/Api/apiPrice";
import { SummaryCard } from "../Card/SummaryCard";
import moment from "moment";

type MonitorInvoicedSummaryCardProps = {
	children: React.ReactNode;
}

export const MonitorInvoicedSummaryCard: React.FunctionComponent<MonitorInvoicedSummaryCardProps> = ({
	children,
}) => {
	return (
		<SummaryCard>
			{children}
		</SummaryCard>
	);
}

type MonitorPaygSummaryCardProps = {
	summary: MonitorPaygPrice;
	showDescription?: boolean;
	children: React.ReactNode;
}

export const MonitorPaygSummaryCard: React.FunctionComponent<MonitorPaygSummaryCardProps> = ({
	summary,
	showDescription = false,
	children,
}) => {
	return (
		<SummaryCard>
			{children && <>{children}</>}
			{summary && showDescription && (
				<>
					<p><span><strong>Name: </strong> {summary.name}</span></p>
					<p><span><strong>Start Date: </strong> {moment().format('Do MMMM YYYY')}</span></p>
					<p><span><strong>End Date: </strong>{moment().add(summary.billingPeriod, 'M').format('Do MMMM YYYY')}</span></p>
				</>
			)}
		</SummaryCard>
	);
}